import React from 'react';
import { translate } from 'react-i18next';
import CBMediaQuery from '../shared/CBMediaQuery';
import { getStyle } from '../../utils/utils';
import NotificationCardHeader from './NotificationCardHeader';
import NotificationToggleRow from './NotificationToggleRow';
import { styles } from './notificationSettingsStyles';

// Service portal: one care-service switch per workshop.
const NotificationWorkshopCard = ({
  t, workshops, onToggle, disabled,
}) => (
  <CBMediaQuery>
    {screenSize => (
      <div style={getStyle(screenSize, styles, 'card')} data-testid='workshop-card'>
        <NotificationCardHeader
          icon='pi pi-wrench'
          title={t('workshopTitle')}
          description={t('workshopDescription')}
        />
        {workshops.map((workshop, index) => (
          <NotificationToggleRow
            key={workshop.id}
            first={index === 0}
            testId={`workshop-switch-${workshop.id}`}
            label={workshop.name}
            hint={t('workshopSwitchHint')}
            checked={workshop.enabled}
            disabled={disabled}
            onChange={checked => onToggle('workshop', workshop.id, checked)}
          />
        ))}
      </div>
    )}
  </CBMediaQuery>
);

export default translate('NotificationSettings')(NotificationWorkshopCard);
